import { createSlice } from "@reduxjs/toolkit";
import { FilterStateJustification } from "./types";

const INITIAL_STATE: FilterStateJustification = {
  filters: {
    search: "",
    meta: {
      page: 1,
    },
  },
};

const justificationFilterSlice = createSlice({
  name: "justificationFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setJustificationFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setJustificationFilter } = justificationFilterSlice.actions;
export default justificationFilterSlice.reducer;
